export enum VerifiedStatus {
    VERIFIED = "verified",
    PENDING = "pending",
    DEACTIVE = "deactive"
  }